import { render, staticRenderFns } from "./candidate-list-skeleton.vue?vue&type=template&id=0d9ca6b0"
import script from "./candidate-list-skeleton.vue?vue&type=script&lang=js"
export * from "./candidate-list-skeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports